"use client";
import { Post } from "@/constants/types";
import { useLanguage } from "@/context/LanguageContext";
import React from "react";
import ProgressiveImage from "../ui/ProgressiveImage";
import { dateFormat, limitText } from "@/utils";
import Link from "next/link";

const ActivityCard = ({ col = 4, post }: { col?: number; post: Post }) => {
  const { t } = useLanguage();
  return (
    <div
      className={`col-xl-${col} col-lg-${col} col-md-6 mb-30 wow tpfadeUp`}
      data-wow-duration=".9s"
      data-wow-delay=".3s"
    >
      <div className="tp-event__wrapper">
        <div className="tp-event__item">
          <div className="tp-event__thumb p-relative">
            <ProgressiveImage url={post.image} />
          </div>
          <div className="tp-event__content">
            <div className="tp-event__meta">
              <span>
                <i className="far fa-calendar"></i>
                {dateFormat(post?.start)} - {dateFormat(post?.end)}
              </span>
              <Link href={`/activities/${post?.slug}`}>
                <span>
                  <i className="fal fa-map-marker-alt"></i>
                  {limitText(post?.adresse, 10)}
                </span>
              </Link>
            </div>
            <Link href={`/activities/${post?.slug}`}>
              <h4 className="tp-event__title">{limitText(post?.title, 40)}</h4>
            </Link>
            <div className="tp-event__link">
              <Link href={`/activities/${post?.slug}`}>
                {t("ReadMore")}
                <i className="fal fa-long-arrow-right"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivityCard;
